import { getScheduleEventBadgeStyles } from 'pages/pga-coach/dashboard/todays-schedule/schedule-event-colors'

export const getCalendarEventTheme = eventType => {
  const badgeStyles = getScheduleEventBadgeStyles(eventType)

  return {
    backgroundColor: badgeStyles.backgroundColor,
    color: badgeStyles.color,
  }
}
